var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoTableChairGSelected = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M4 3.9h12l.902 9.928a3 3 0 0 1-2.987 3.272h-7.83a3 3 0 0 1-2.988-3.272L4 3.9Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeWidth: 2,
  d: "M13.915 16.1h-7.83a2 2 0 0 1-1.992-2.181l.218-2.4a2 2 0 0 1 1.992-1.82h7.394a2 2 0 0 1 1.991 1.82l.218 2.4a2 2 0 0 1-1.991 2.181Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m2.8 6.3.267-.534A3.375 3.375 0 0 1 6.086 3.9h7.828c1.278 0 2.447.722 3.019 1.866l.267.534"
})));
SvgNoTableChairGSelected.viewBox = '0 0 20 20';
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoTableChairGSelected);
export default ForwardRef;